import { BOT_ROUTES } from 'constants/bot/routes'
export const GoogleScopes = Object.freeze({
  CALENDAR: 'https://www.googleapis.com/auth/calendar',
  READ: 'https://www.googleapis.com/auth/gmail.readonly',
  SEND: 'https://www.googleapis.com/auth/gmail.send',
})

export const PAGE_TITLES = [
  { path: '/account', title: 'Account' },
  { path: '/profile', title: 'Drift Profile' },
  { path: '/company', title: 'Company details' },
  { path: '/security', title: 'Security' },
  {
    path: '/security/saml',
    title: 'SAML Authentication',
    breadcrumbs: [
      { title: 'Security', link: '/settings2/security' },
      { title: 'SAML Authentication', link: '.', isActive: true },
    ],
  },
  { path: '/consent', title: 'Data privacy' },
  { path: '/widget', title: 'Drift Widget' },
  { path: '/enterprise-widget', title: 'Drift Widget' },
  { path: BOT_ROUTES.BOT_SETTINGS, title: 'Bot' },
  { path: '/teams', title: 'Teams' },
  { path: '/billing', title: 'Plan and billing' },
  { path: '/gpt', title: 'GPT features' },
  {
    path: '/gpt/bot-voice',
    title: 'AI Bot Voice Customization',
    breadcrumbs: [
      { title: 'GPT features', link: '/settings2/gpt' },
      { title: 'AI Bot Voice Customization', link: '.', isActive: true },
    ],
  },
  { path: '/deal-admin', title: 'Drift Admin Panel' },
  { path: '/integrations', title: 'Integrations' },
  { path: '/notifications', title: 'Notifications' },
  { path: '/notificationsV2', title: 'Notifications' },
  { path: '/email', title: 'Email' },
  { path: '/workspaces', title: 'Workspaces and teams' },
  { path: '/prospector', title: 'Prospector' },
  {
    path: '/team/invite',
    title: 'Invite teammates',
    breadcrumbs: [
      { title: 'Manage teammates', link: '/settings2/team' },
      { title: 'Invite teammates', link: '.', isActive: true },
    ],
  },
  {
    path: '/widget/hours',
    title: 'Hours',
    breadcrumbs: [
      { title: 'Drift Widget', link: '/settings2/widget' },
      { title: 'Hours', link: '.', isActive: true },
    ],
  },
  {
    path: '/widget/default-greeting',
    title: 'Default greeting',
    breadcrumbs: [
      { title: 'Drift Widget', link: '/settings2/widget' },
      { title: 'Default greeting', link: '.', isActive: true },
    ],
  },
  {
    path: '/widget/design',
    title: 'Design and language',
    breadcrumbs: [
      { title: 'Drift Widget', link: '/settings2/widget' },
      { title: 'Design and language', link: '.', isActive: true },
    ],
  },
  {
    path: '/conversations',
    title: 'Conversations',
  },
  {
    path: '/conversations/advanced',
    title: 'Advanced conversation settings',
    breadcrumbs: [
      { title: 'Conversations', link: '/settings2/conversations' },
      { title: 'Advanced conversation settings', link: '.', isActive: true },
    ],
  },
  {
    path: '/replies',
    title: 'Saved replies',
    breadcrumbs: [
      { title: 'Conversations', link: '/settings2/conversations' },
      { title: 'Saved replies', link: '.', isActive: true },
    ],
  },
  {
    path: '/dkim',
    title: 'Email sending domains',
    breadcrumbs: [
      { title: 'Conversations', link: '/settings2/conversations' },
      { title: 'Email sending domains', link: '.', isActive: true },
    ],
  },
  {
    path: '/user-logs',
    title: 'Teammate activity log',
    breadcrumbs: [
      { title: 'Teammate settings', link: '/settings2/team' },
      { title: 'Teammate activity log', link: '.', isActive: true },
    ],
  },
  {
    path: BOT_ROUTES.CENTRAL_ROUTING,
    title: 'Special routing fallbacks',
    breadcrumbs: [
      { title: 'Bot', link: '/settings2/bot' },
      { title: 'Special routing fallbacks', link: '.', isActive: true },
    ],
  },
  {
    path: BOT_ROUTES.KEYWORDS,
    title: 'Saved keywords groups',
    breadcrumbs: [
      { title: 'Bot', link: '/settings2/bot' },
      { title: 'Saved keywords groups', link: '.', isActive: true },
    ],
  },
  {
    path: BOT_ROUTES.ABANDONED_SCHEDULING,
    title: 'Abandoned scheduling',
    breadcrumbs: [
      { title: 'Bot', link: '/settings2/bot' },
      { title: 'Abandoned scheduling', link: '.', isActive: true },
    ],
  },
  {
    path: BOT_ROUTES.CONVERSATIONAL_LANDING_PAGES,
    title: 'Conversational landing pages',
    breadcrumbs: [
      { title: 'Bot', link: '/settings2/bot' },
      { title: 'Conversational landing pages', link: '.', isActive: true },
    ],
  },
  {
    path: BOT_ROUTES.SUPPORT,
    title: 'Support',
    breadcrumbs: [
      { title: 'Bot', link: '/settings2/bot' },
      { title: 'Support', link: '.', isActive: true },
    ],
  },
  {
    path: BOT_ROUTES.CONVERSATION_RATINGS,
    title: 'Conversation ratings',
    breadcrumbs: [
      { title: 'Bot', link: '/settings2/bot' },
      { title: 'Conversation ratings', link: '.', isActive: true },
    ],
  },
]

export const STANDARD_WIDGET_PAGE_TITLES = [
  ...PAGE_TITLES,
  {
    path: '/widget/advanced',
    title: 'Advanced',
    breadcrumbs: [
      { title: 'Drift Widget', link: '/settings2/widget' },
      { title: 'Advanced', link: '.', isActive: true },
    ],
  },
  {
    path: '/widget/security',
    title: 'Widget security',
    breadcrumbs: [
      { title: 'Drift Widget', link: '/settings2/widget' },
      { title: 'Widget security', link: '.', isActive: true },
    ],
  },
  {
    path: '/widget/install',
    title: 'Install',
    breadcrumbs: [
      { title: 'Drift Widget', link: '/settings2/widget' },
      { title: 'Install', link: '.', isActive: true },
    ],
  },
]

export const BRANDED_WIDGET_PAGE_TITLES = [
  ...PAGE_TITLES,
  {
    path: '/widget/advanced',
    title: 'Drift Widget',
  },
  {
    path: '/widget/security',
    title: 'Drift Widget',
  },
  {
    path: '/widget/install',
    title: 'Drift Widget',
  },
]

export const HEADER_NAVS = Object.freeze({
  BRANDS: [
    {
      label: 'Widgets',
      route: '/widget',
    },
    {
      label: 'Advanced settings',
      route: '/widget/advanced',
    },
    {
      label: 'Security',
      route: '/widget/security',
    },
    {
      label: 'Install',
      route: '/widget/install',
    },
  ].map((item) => ({
    ...item,
    onClick: ({ history }) => history.push(item.route),
  })),
})

/* Routes to use new settings layout */
export const V2_SETTINGS_EXACT_ROUTES = [
  { path: '/team', page: 'Manage teammates' },
  { path: '/team/teammates', page: 'Manage teammates' },
  { path: '/team/roles', page: 'Manage teammates' },
  { path: '/team/invitations', page: 'Manage teammates' },
  { path: '/team/requests', page: 'Manage teammates' },
]

/* Base routes where all child pages should use the new settings layout */
export const V2_SETTINGS_BASE_ROUTES = [
  { path: '/workspaces2', page: 'Workspaces and teams' },
]
